var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mainTemplate',[_c('Main'),_c('template',{slot:"bus"},[_c('question-bus')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }